import { invoiceManageAction, getType } from '../../actions';
import { getTodayMonth } from '../../../utils/Date/SupportDate'

const initialState = {
    loading: true,
    content: [],
    month: getTodayMonth()
}

const invoiceManageReducer = (state = initialState, action) => {
    switch (action.type) {
        case getType(invoiceManageAction.resetInvoiceManage): {
            return {
                loading: true,
                content: [],
            };
        }

        case getType(invoiceManageAction.fillInvoiceManage): {
            return action.payload;
        }


        default: return state;
    }
}

export default invoiceManageReducer;
